import { createReducer, on } from "@ngrx/store"
import { setForm } from "./vehicle.actions"

export type VehicleState = {
    form?: {
        resetCityAutocomplete: boolean
    }
}

const initialState: VehicleState = {}

export const vehicleReducer = createReducer(
    initialState,
    on(
        setForm,
        (state, { form }) => ({
            ...state,
            form: { ...form }
        })
    )
)
